import { z } from "zod";

export const CreateExclusionGroupEntityDtoSchema = z.object({
  id: z.string().uuid().optional(),
  experienceId: z.string().uuid(),
  percentage: z.number(),
  order: z.number(),
  hasPriorityOrder: z.boolean().default(false),
});
export type CreateExclusionGroupEntityDto = z.infer<
  typeof CreateExclusionGroupEntityDtoSchema
>;

export type ExclusionGroupEntityDto = z.infer<
  typeof ExclusionGroupEntityDtoSchema
>;

// on creation of new exclusion group
export const CreateExclusionGroupDtoSchema = z.object({
  id: z.string().uuid().optional(),
  name: z.string(),
  exclusionGroupEntities: CreateExclusionGroupEntityDtoSchema.array().default(
    []
  ),
  reassignOnEnd: z.boolean().default(false),
  hasWeightedValues: z.boolean().default(false),
});

export type CreateExclusionGroupDto = z.infer<
  typeof CreateExclusionGroupDtoSchema
>;

// full exclusion entity with no optional IDs
export const ExclusionGroupEntityDtoSchema =
  CreateExclusionGroupEntityDtoSchema.extend({
    id: z.string().uuid(),
    experienceId: z.string().uuid(),
  });

export const ExclusionGroupDtoSchema = CreateExclusionGroupDtoSchema.extend({
  id: z.string().uuid(),
});

export type ExclusionGroupDto = z.infer<typeof ExclusionGroupDtoSchema>;

export const CreateExclusionGroupEntityOnCreateSchema =
  CreateExclusionGroupEntityDtoSchema.extend({
    experienceId: z.string().uuid().optional(),
  });

export const CreateExclusionGroupOnCreateSchema =
  CreateExclusionGroupDtoSchema.extend({
    exclusionGroupEntities:
      CreateExclusionGroupEntityOnCreateSchema.array().default([]),
  });

export type CreateExclusionGroupOnCreate = z.infer<
  typeof CreateExclusionGroupOnCreateSchema
>;
